import React, { useEffect, useState } from 'react';
import { Building2 } from 'lucide-react';
import CustomerAdmin from './CustomerAdmin';
import apiService from '../services/apiService';
import { getFeatures } from '../utils/featuresCache';
import { useI18n } from '../utils/i18n';

// #87: Eigenständige Kundenverwaltungs-Seite für Manager (Einstieg über das
// Optionen-Menü). Nutzt dieselbe Komponente wie der Admin-Tab „Kunden";
// die Server-Routen verlangen Manager- oder Admin-Rechte (requireManagerOrAdmin).
const CustomersPage = () => {
  const { t } = useI18n();
  const [state, setState] = useState('loading'); // loading | ok | forbidden | disabled

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const features = await getFeatures();
        if (features.customers === false) {
          if (!cancelled) setState('disabled');
          return;
        }
        const u = await apiService.getUser();
        const ok = !!(u?.dbUser?.isManager || u?.dbUser?.isAdmin);
        if (!cancelled) setState(ok ? 'ok' : 'forbidden');
      } catch (_) {
        if (!cancelled) setState('forbidden');
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="container">
      <div className="admin-panel">
        <div className="admin-header">
          <h1>
            <Building2 size={32} style={{ color: 'var(--color-primary)' }} />
            {t('customersPage.title', 'Kundenverwaltung')}
          </h1>
        </div>
        {state === 'loading' && <p className="section-description">{t('common.loading', 'Lade...')}</p>}
        {state === 'disabled' && (
          <div className="alert alert-error">{t('customersPage.disabled', 'Das Kunden-Feature ist auf diesem System deaktiviert.')}</div>
        )}
        {state === 'forbidden' && (
          <div className="alert alert-error">{t('customersPage.forbidden', 'Die Kundenverwaltung ist Managern vorbehalten.')}</div>
        )}
        {state === 'ok' && <CustomerAdmin />}
      </div>
    </div>
  );
};

export default CustomersPage;
